import { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { LinkButtonBlue, CustomButton, Modal } from "@helloaudio/ui";
import { TrashIcon, DeleteEpisodeSVG } from "@helloaudio/icons/twotone";
import moment from "moment";

function DeleteEpisodeModal({ feedEpisode, existingFeedEpisodeId, values }) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const onClose = () => {
    setShowModal(false);
  };

  const onConfirm = () => {
    setIsLoading(true);
    dispatch({
      type: "UPDATE_EPISODE_STATUS",
      feedEpisodeId: existingFeedEpisodeId,
      status: "deleted",
      feedId: feedEpisode.feed_id,
      callback: () => {
        dispatch({
          type: "UPDATE_FEED_EPISODE",
          feedEpisodeId: existingFeedEpisodeId,
          title: values.title,
          description: values.description,
          ordering: values.ordering,
          publishDate: moment(values.publish_date).unix(),
          dripAfter: values.dripAfter,
          explicit: values.explicit,
          feedId: feedEpisode.feed_id,
          silent: true,
          season: feedEpisode.season,
          expirationDripAfter: values.expiry === "after" ? values.expirationDripAfter : null,
          listenerTagsExpression: {
            or: values.tags.map((tag) => {
              return {
                some: [{ var: "tags" }, { "==": [{ var: "" }, tag.name] }],
              };
            }),
          },
          useDolby: values.useDolby,
          episodeType: values.episodeType,
          universalFooter: values.universalFooter,
          callback: () => {
            setIsLoading(false);
          },
        });
      },
    });
  };

  return (
    <>
      <LinkButtonBlue
        className="feed-subTitle audio-inbox-link-btn hover:tw-no-underline tw-my-0"
        onClick={(e) => {
          e.preventDefault();
          setShowModal(true);
        }}
        type="button"
      >
        <div className="tw-flex tw-items-center audio-inbox-disconnect">
          <TrashIcon className="tw-w-4 tw-h-4 tw-mr-2" />
          <p className="tw-text-sm">Delete Episode</p>
        </div>
      </LinkButtonBlue>

      <Modal
        title={"Delete Episode"}
        visible={showModal}
        onClose={onClose}
        actions={[
          <CustomButton className="custom-btn-danger tw-mr-4" key={1} onClick={onClose}>
            Cancel
          </CustomButton>,
          <CustomButton accent="primary" key={2} onClick={onConfirm} loading={isLoading}>
            Confirm
          </CustomButton>,
        ]}
      >
        <div className="tw-p-4">
          <p className="tw-text-center description-grey">
            Are you sure you want to delete this episode?
          </p>
          <div className="tw-flex tw-justify-center tw-my-4">
            <DeleteEpisodeSVG className="tw-mr-4" />
          </div>
        </div>
      </Modal>
    </>
  );
}

DeleteEpisodeModal.propTypes = {
  existingFeedEpisodeId: PropTypes.string.isRequired,
  feedEpisode: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
};

export default DeleteEpisodeModal;
